import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormControlName, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ListaUserTerceiroService } from './lista-user-terceiro.service';
import { HttpParams } from '@angular/common/http';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { SpringDatatablePagination } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DatatableService } from '../../../../shared/services/datatable.service';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngx-cadastro-user-terceiro',
  templateUrl: './lista-user-terceiro.component.html',
  styleUrls: ['./lista-user-terceiro.component.scss']
})
export class ListaUserTerceiroComponent implements OnInit,OnDestroy {

  public formListaTerceiro = null;
  public tableLimit = 10;
  public rowData = null;
  public userTerceiro = null;
  public customLogin = null;
  
  @ViewChild('myTable', null)
  public table: DatatableComponent;

  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;

  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  public listStatus = [
    { description: 'ATIVO', value: 'ATIVO' },
    { description: 'INATIVO', value: 'INATIVO' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private paginationService: SpringDatatablePaginationService,
    private datatableService: DatatableService,
    private service: ListaUserTerceiroService,
    private notifications: NotificationsService,
    private spinnerService: NgxSpinnerService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.table);

    this.formListaTerceiro = this.formBuilder.group({
      id: [null],
      cpf: [null],
      nome: [null],
      telefone: [null],
      status: '',
    });

    this.buscarUser(this.formListaTerceiro.value);

  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.table);
  }

  opencadastro() {

    this.router.navigate(['/pages/gestao-user-terceiro/cadastro-user-terceiro']);

  }

  buscarUserSetSortParams(sortArray: any): string {
    if (sortArray && sortArray != null && sortArray.length > 0 ) {
      let dataToOrder: any = sortArray[0];
      return ''.concat(dataToOrder.prop, ',', dataToOrder.dir);
    }
    return ''.concat('nome', ',', 'asc');
  }

  buscarUser(data: any, page?: any, sorts?: any) {

    let params = new HttpParams();
    params = params.append('size', String(this.tableLimit));

    if (data.cpf != null) {
      params = params.append('cpf', data.cpf);

    }
    if (data.nome != null) {
      params = params.append('nome', data.nome);
    }
    if (data.status !== '') {
      params = params.append('status', data.status);
    }

    if (page && page != null) {
       params = params.append('page', String(page - 1));
    }

    let sortData: any = this.buscarUserSetSortParams(sorts);
    params = params.append('sort', sortData);


    this.spinnerService.show();
    this.service.buscaUsuario(params, (response => {

      this.rowData = response.content;
      this.userTerceiro = response.content.length;
      this.paginationService.setInfo(response);

      if (this.userTerceiro == 0 ) {
        this.notifications.error(
          "CPF ou Nome não encontrado!"
        )
      }
      this.spinnerService.hide();

    }), err => {
      this.spinnerService.hide();
      this.notifications.error('Não foi possível realizar a consulta.');
    });

  }

  gotoEdit(data) {

    this.router.navigate(['../cadastro-user-terceiro', data.id], { relativeTo: this.route });

  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
